module.exports = __webpack_public_path__ + "img/right9.a7eb657f.png";